import type { AppDispatch } from '@/store';
import type { MappedSixesCatalogResponse } from '@/store/mappers/sixCatalog';
import { initializeP2PStackThunk } from '@/store/thunks/poc/connection/initializeP2PStackThunk';

/**
 * Initializes the P2P stack for every six in the catalog that advertises
 * bootstrap nodes. Safe to call on both initial fetch and subsequent refresh:
 * initializeP2PStackThunk's condition skips sixes that are already connecting
 * or initialized, so only newly-appeared sixes trigger a connection.
 */
export function initializeP2PStacksForCatalog(
  dispatch: AppDispatch,
  sixes: MappedSixesCatalogResponse['sixes']
): void {
  const allBootstrapNodes = [
    ...new Set(
      sixes
        .flatMap((six) => six.bootstrapNodes)
        .map((node) => node.trim())
        .filter((node) => node.length > 0)
    ),
  ];

  for (const six of sixes) {
    const sixHasBootstrapNodes = six.bootstrapNodes.map((n) => n.trim()).some((n) => n.length > 0);

    if (!sixHasBootstrapNodes) {
      continue;
    }

    void dispatch(
      initializeP2PStackThunk({
        sixId: six.id,
        bootstrapNodes: allBootstrapNodes,
      })
    );
  }
}
